import { EInfrastructureActionTypes } from '../../actions/infrastructure';
import { TInfrastructureState } from '../../types/map';
import { TReduxActions } from '../../types/redux';

export const defaultState: TInfrastructureState = {
  regularInfrastructureItems: [],
};

export function infrastructureReducer(
  state: TInfrastructureState = defaultState,
  action: TReduxActions,
): TInfrastructureState {
  switch (action.type) {
    case EInfrastructureActionTypes.SetInfrastructure:
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
}
